import { useState } from "react";
import { Link } from "react-router-dom";
import { allComics, formatCount } from "@/utils/comics";

const tabs = [
  { id: "views", label: "人气榜" },
  { id: "likes", label: "收藏榜" },
];

export default function HotRanking() {
  const [tab, setTab] = useState("views");

  const ranking = [...allComics]
    .sort((a, b) => (tab === "views" ? b.viewCount - a.viewCount : b.likeCount - a.likeCount))
    .slice(0, 6);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-1.5 font-heading text-base font-bold text-foreground-950">
          <i className="ri-bar-chart-box-line text-lg text-primary-500"></i>
          热播排行
        </h3>
        <div className="flex rounded-full bg-background-100 p-1">
          {tabs.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setTab(item.id)}
              className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium transition-colors ${
                tab === item.id
                  ? "bg-background-50 text-primary-700"
                  : "text-foreground-500 hover:text-foreground-800"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <ul className="space-y-2">
        {ranking.map((comic, index) => (
          <li key={comic.id}>
            <Link
              to={`/detail/${comic.id}`}
              className="group flex items-center gap-2.5 rounded-md p-1.5 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                  index < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {index + 1}
              </span>
              <span className="h-12 w-9 shrink-0 overflow-hidden rounded bg-secondary-100">
                <img
                  src={comic.cover}
                  alt={`${comic.title}封面`}
                  title={`${comic.title} - JMComic热播排行`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-xs font-semibold text-foreground-900 group-hover:text-primary-700">
                  {comic.title}
                </span>
                <span className="mt-0.5 block truncate text-[10px] text-foreground-400">
                  {comic.categoryName} · {comic.status}
                </span>
              </span>
              <span className="shrink-0 text-[10px] font-medium text-foreground-500">
                {formatCount(tab === "views" ? comic.viewCount : comic.likeCount)}
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/category/all"
        className="mt-3 flex h-9 items-center justify-center gap-1 rounded-md border border-background-200 text-xs font-medium text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        查看完整榜单
        <i className="ri-arrow-right-line"></i>
      </Link>
    </section>
  );
}